import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import CookieConsent from 'react-cookie-consent';

const CookieBanner = () => {
  const [button, setButton] = useState();

  useEffect(() => {
    const buttonId = document.getElementById('accept-button');
    setButton(buttonId);
  }, [button]);

  if (button) {
    button.parentElement.className =
      'inline-block w-full p-px rounded-full cursor-pointer sm:w-auto bg-gradient-x hover:bg-gradient-to-r from-white to-white group';
  }

  return (
    <CookieConsent
      location="none"
      buttonText="Accept Cookies"
      buttonId="accept-button"
      disableStyles
      containerClasses="fixed bottom-6 md:bottom-10 flex lg:w-fit w-11/12 sm:flex-row flex-col bg-[#262626]/60 backdrop-blur left-1/2 -translate-x-1/2 rounded-lg lg:rounded-[66px] text-sm text-white py-4 px-6 justify-center items-center z-10 gap-4"
      contentClasses="lg:flex-shrink-0 flex flex-col sm:flex-row items-center gap-4 sm:gap-8"
      buttonClasses="w-full sm:w-auto text-white bg-black group-hover:text-black group-hover:bg-white text-sm px-4 py-1.5 leading-5 font-medium tracking-wide inline-block rounded-full whitespace-nowrap transition-color duration-200 uppercase"
    >
      <div>
        We use cookies to improve your experience and for analytics. Learn more in our&nbsp;
        <Link href="/legal/terms" target="_blank" rel="noreferrer">
          <a className="font-bold">cookie policy.</a>
        </Link>
      </div>
      <div className="inline-block w-full p-px bg-white rounded-full sm:w-auto bg-opacity-30 hover:bg-gradient-to-r from-white to-white group">
        <button type="button" className="ot-sdk-show-settings" id="ot-sdk-btn">
          Settings
        </button>
      </div>
    </CookieConsent>
  );
};

export default CookieBanner;
